"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var ytjActions = require("@caddigital/sok-reducers/lib/actions/customer/ytj");
var wizardActions = require("@caddigital/sok-reducers/lib/actions/customer/wizard");
var NewCustomer_1 = require("./NewCustomer");
var EnterpriseFeatures_1 = require("./EnterpriseFeatures");
var types_1 = require("types");
var mapStateToProps = function (state) {
    return {
        wizard: state.customer.wizard,
        step1: state.customer.wizard.step1,
        salesman: state.customer.salesman,
        region: state.customer.region,
        ytj: state.customer.ytj,
        allFeatures: state.features.all.all,
        allFeaturesStatus: state.features.all.status,
        viewport: state.viewport.size
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    updateField: function (key) { return function (value) {
        return dispatch(wizardActions.updateField(key, value));
    }; },
    setFiles: function (files) {
        return dispatch(wizardActions.setFiles(files));
    },
    removeFile: function (file) { return function () {
        return dispatch(wizardActions.removeFile(file));
    }; },
    setCompanyLogo: function (file, dataUrl) {
        return dispatch(wizardActions.setCompanyLogo(file, dataUrl));
    },
    removeCompanyLogo: function () { return dispatch(wizardActions.setCompanyLogo()); },
    setCountry: function (region) {
        return dispatch(wizardActions.updateField('country', region.code));
    },
    setYtjSearchString: function (searchString) {
        dispatch(ytjActions.setSearchString(searchString));
        searchString && dispatch(ytjActions.searchYtjRequest(searchString));
    },
    setCompany: function (company) {
        return dispatch(wizardActions.setYtjCompanyRequest(company));
    },
    setSalesman: function (user) {
        return dispatch(wizardActions.updateField('salesman', Array.isArray(user) ? null : user.id));
    },
    saveCustomer: function (props) { return function () {
        return dispatch(wizardActions.saveCustomerRequest(props.wizard.customerUuid, {
            type: 'ADMIN',
            name: props.step1.companyName,
            hasBusinessId: props.step1.hasBusinessId,
            businessId: props.step1.businessId,
            street: props.step1.street,
            postalCode: props.step1.postalCode,
            city: props.step1.city,
            state: props.step1.state,
            country: props.step1.country,
            client: props.step1.client,
            salesRepresentative: props.step1.salesman,
            features: props.step1.features
        }, props.step1.companyLogo.file, props.step1.files));
    }; },
    toggleClient: function () { return dispatch(wizardActions.toggleClient()); },
    select: function (feature) { return dispatch(wizardActions.select(feature)); },
    unselect: function (feature) {
        return dispatch(wizardActions.unselect(feature));
    },
    updatePrice: function (uuid, price) {
        return dispatch(wizardActions.updatePrice(uuid, price));
    }
}); };
var statePropsExtractable = (0, types_1.extractReturnType)(mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(mapDispatchToProps);
var handleSaveText = function (props) {
    if (props.wizard.saveCustomer === 'SAVING' ||
        props.wizard.uploadingContractFiles === 'UPLOADING') {
        return React.createElement(sok_ui_1.LoadingSpinner, null);
    }
    return (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/button/saveCurrentStep');
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('tempValue', 'setTempValue', null));
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'step1' },
    React.createElement("div", { className: 'save-button' },
        React.createElement(sok_ui_1.Button, { color: 'base-green', text: handleSaveText(props), onClick: props.saveCustomer(props) })),
    React.createElement(sok_ui_1.BoxLayout, { direction: props.viewport === 'DESKTOP' ? 'row' : 'column' },
        React.createElement(sok_ui_1.Panel, { icon: React.createElement(sok_ui_1.Icon, { className: 'icofont-under-construction-alt' }), title: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation'), disableCollapse: true },
            React.createElement(NewCustomer_1.default, __assign({}, props))),
        React.createElement(sok_ui_1.BoxLayout, { direction: 'row' },
            React.createElement(sok_ui_1.Panel, { icon: React.createElement(sok_ui_1.Icon, { className: 'icofont-tools-alt-2' }), title: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/EnterpriseFeaturesPrices'), disableCollapse: true },
                React.createElement(EnterpriseFeatures_1.default, { customerId: props.wizard.customerId, allFeatures: props.allFeatures, select: props.select, unselect: props.unselect, updatePrice: props.updatePrice, featuresStatus: props.wizard.step1.featuresStatus, features: props.wizard.step1.features, allFeaturesStatus: props.wizard.step1.featuresStatus, wizard: props.wizard, errors: props.step1.status === 'ERROR' ? props.step1.errors : undefined })))),
    React.createElement(sok_ui_1.RequestStatusBox, { status: props.wizard.saveCustomer, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILURE'] },
        React.createElement("span", null, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/button/saving')),
        React.createElement("span", null, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/button/saved')),
        React.createElement("span", null, props.wizard.saveError &&
            props.wizard.saveError.type === 'CONFLICT' &&
            props.wizard.saveError.message === 'Customer already exits'
            ? (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/button/customerExists')
            : (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/button/errorSaving'))))); });
